export default __webpack_public_path__ + "static/media/trr-drink-specialty-taro.e337085c.png";